import { render, staticRenderFns } from "./reenviarRps.vue?vue&type=template&id=c72a3408"
import script from "./reenviarRps.vue?vue&type=script&lang=js"
export * from "./reenviarRps.vue?vue&type=script&lang=js"
import style0 from "./reenviarRps.vue?vue&type=style&index=0&id=c72a3408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports